/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// require('./plugins/loadImg');
	
	__webpack_require__(2);
	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(6);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * what-input - A global utility for tracking the current input method (mouse, keyboard or touch).
	 * @version v4.3.1
	 * @link https://github.com/ten1seven/what-input
	 * @license MIT
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("whatInput", [], factory);
		else if(typeof exports === 'object')
			exports["whatInput"] = factory();
		else
			root["whatInput"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = function () {
		  /*
		   * variables
		   */
	
		  // last used input type
		  var currentInput = 'initial';
	
		  // last used input intent
		  var currentIntent = null;
	
		  // cache document.documentElement
		  var doc = document.documentElement;
	
		  // form input types
		  var formInputs = ['input', 'select', 'textarea'];
	
		  var functionList = [];
	
		  // list of modifier keys commonly used with the mouse and
		  // can be safely ignored to prevent false keyboard detection
		  var ignoreMap = [16, // shift
		  17, // control
		  18, // alt
		  91, // Windows key / left Apple cmd
		  93 // Windows menu / right Apple cmd
		  ];
	
		  // list of keys for which we change intent even for form inputs
		  var changeIntentMap = [9 // tab
		  ];
	
		  // mapping of events to input types
		  var inputMap = {
		    keydown: 'keyboard',
		    keyup: 'keyboard',
		    mousedown: 'mouse',
		    mousemove: 'mouse',
		    MSPointerDown: 'pointer',
		    MSPointerMove: 'pointer',
		    pointerdown: 'pointer',
		    pointermove: 'pointer',
		    touchstart: 'touch'
		  };
	
		  // array of all used input types
		  var inputTypes = [];
	
		  // boolean: true if touch buffer is active
		  var isBuffering = false;
	
		  // boolean: true if the page is being scrolled
		  var isScrolling = false;
	
		  // store current mouse position
		  var mousePos = {
		    x: null,
		    y: null
		  };
	
		  // map of IE 10 pointer events
		  var pointerMap = {
		    2: 'touch',
		    3: 'touch', // treat pen like touch
		    4: 'mouse'
		  };
	
		  var supportsPassive = false;
	
		  try {
		    var opts = Object.defineProperty({}, 'passive', {
		      get: function get() {
		        supportsPassive = true;
		      }
		    });
	
		    window.addEventListener('test', null, opts);
		  } catch (e) {}
	
		  /*
		   * set up
		   */
	
		  var setUp = function setUp() {
		    // add correct mouse wheel event mapping to `inputMap`
		    inputMap[detectWheel()] = 'mouse';
	
		    addListeners();
		    setInput();
		  };
	
		  /*
		   * events
		   */
	
		  var addListeners = function addListeners() {
		    // `pointermove`, `MSPointerMove`, `mousemove` and mouse wheel event binding
		    // can only demonstrate potential, but not actual, interaction
		    // and are treated separately
		    var options = supportsPassive ? { passive: true } : false;
	
		    // pointer events (mouse, pen, touch)
		    if (window.PointerEvent) {
		      doc.addEventListener('pointerdown', updateInput);
		      doc.addEventListener('pointermove', setIntent);
		    } else if (window.MSPointerEvent) {
		      doc.addEventListener('MSPointerDown', updateInput);
		      doc.addEventListener('MSPointerMove', setIntent);
		    } else {
		      // mouse events
		      doc.addEventListener('mousedown', updateInput);
		      doc.addEventListener('mousemove', setIntent);
	
		      // touch events
		      if ('ontouchstart' in window) {
		        doc.addEventListener('touchstart', touchBuffer, options);
		        doc.addEventListener('touchend', touchBuffer);
		      }
		    }
	
		    // mouse wheel
		    doc.addEventListener(detectWheel(), setIntent, options);
	
		    // keyboard events
		    doc.addEventListener('keydown', updateInput);
		    doc.addEventListener('keyup', updateInput);
		  };
	
		  // checks conditions before updating new input
		  var updateInput = function updateInput(event) {
		    // only execute if the touch buffer timer isn't running
		    if (!isBuffering) {
		      var eventKey = event.which;
		      var value = inputMap[event.type];
		      if (value === 'pointer') value = pointerType(event);
	
		      if (currentInput !== value || currentIntent !== value) {
		        var activeElem = document.activeElement;
		        var activeInput = false;
		        var notFormInput = activeElem && activeElem.nodeName && formInputs.indexOf(activeElem.nodeName.toLowerCase()) === -1;
	
		        if (notFormInput || changeIntentMap.indexOf(eventKey) !== -1) {
		          activeInput = true;
		        }
	
		        if (value === 'touch' ||
		        // ignore mouse modifier keys
		        value === 'mouse' ||
		        // don't switch if the current element is a form input
		        value === 'keyboard' && eventKey && activeInput && ignoreMap.indexOf(eventKey) === -1) {
		          // set the current and catch-all variable
		          currentInput = currentIntent = value;
	
		          setInput();
		        }
		      }
		    }
		  };
	
		  // updates the doc and `inputTypes` array with new input
		  var setInput = function setInput() {
		    doc.setAttribute('data-whatinput', currentInput);
		    doc.setAttribute('data-whatintent', currentInput);
	
		    if (inputTypes.indexOf(currentInput) === -1) {
		      inputTypes.push(currentInput);
		      doc.className += ' whatinput-types-' + currentInput;
		    }
	
		    fireFunctions('input');
		  };
	
		  // updates input intent for `mousemove` and `pointermove`
		  var setIntent = function setIntent(event) {
		    // test to see if `mousemove` happened relative to the screen
		    // to detect scrolling versus mousemove
		    if (mousePos['x'] !== event.screenX || mousePos['y'] !== event.screenY) {
		      isScrolling = false;
	
		      mousePos['x'] = event.screenX;
		      mousePos['y'] = event.screenY;
		    } else {
		      isScrolling = true;
		    }
	
		    // only execute if the touch buffer timer isn't running
		    // or scrolling isn't happening
		    if (!isBuffering && !isScrolling) {
		      var value = inputMap[event.type];
		      if (value === 'pointer') value = pointerType(event);
	
		      if (currentIntent !== value) {
		        currentIntent = value;
	
		        doc.setAttribute('data-whatintent', currentIntent);
	
		        fireFunctions('intent');
		      }
		    }
		  };
	
		  // buffers touch events because they frequently also fire mouse events
		  var touchBuffer = function touchBuffer(event) {
		    if (event.type === 'touchstart') {
		      isBuffering = false;
	
		      // set the current input
		      updateInput(event);
		    } else {
		      isBuffering = true;
		    }
		  };
	
		  var fireFunctions = function fireFunctions(type) {
		    for (var i = 0, len = functionList.length; i < len; i++) {
		      if (functionList[i].type === type) {
		        functionList[i].fn.call(undefined, currentIntent);
		      }
		    }
		  };
	
		  /*
		   * utilities
		   */
	
		  var pointerType = function pointerType(event) {
		    if (typeof event.pointerType === 'number') {
		      return pointerMap[event.pointerType];
		    } else {
		      // treat pen like touch
		      return event.pointerType === 'pen' ? 'touch' : event.pointerType;
		    }
		  };
	
		  // detect version of mouse wheel event to use
		  // via https://developer.mozilla.org/en-US/docs/Web/Events/wheel
		  var detectWheel = function detectWheel() {
		    var wheelType = void 0;
	
		    // Modern browsers support "wheel"
		    if ('onwheel' in document.createElement('div')) {
		      wheelType = 'wheel';
		    } else {
		      // Webkit and IE support at least "mousewheel"
		      // or assume that remaining browsers are older Firefox
		      wheelType = document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';
		    }
	
		    return wheelType;
		  };
	
		  var objPos = function objPos(match) {
		    for (var i = 0, len = functionList.length; i < len; i++) {
		      if (functionList[i].fn === match) {
		        return i;
		      }
		    }
		  };
	
		  /*
		   * init
		   */
	
		  // don't start script unless browser cuts the mustard
		  // (also passes if polyfills are used)
		  if ('addEventListener' in window && Array.prototype.indexOf) {
		    setUp();
		  }
	
		  /*
		   * api
		   */
	
		  return {
		    // returns string: the current input type
		    // opt: 'loose'|'strict'
		    // 'strict' (default): returns the same value as the `data-whatinput` attribute
		    // 'loose': includes `data-whatintent` value if it's more current than `data-whatinput`
		    ask: function ask(opt) {
		      return opt === 'loose' ? currentIntent : currentInput;
		    },
	
		    // returns array: all the detected input types
		    types: function types() {
		      return inputTypes;
		    },
	
		    // overwrites ignored keys with provided array
		    ignoreKeys: function ignoreKeys(arr) {
		      ignoreMap = arr;
		    },
	
		    // attach functions to input and intent "events"
		    // funct: function to fire on change
		    // eventType: 'input'|'intent'
		    registerOnChange: function registerOnChange(fn, eventType) {
		      functionList.push({
		        fn: fn,
		        type: eventType || 'input'
		      });
		    },
	
		    unRegisterOnChange: function unRegisterOnChange(fn) {
		      var position = objPos(fn);
	
		      if (position) {
		        functionList.splice(position, 1);
		      }
		    }
		  };
		}();
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	var onClick = function onClick(e) {
	
		if (e.target && e.target.matches('a.external') && e.which !== 2) {
			window.open(e.target.href);
			e.preventDefault();
		}
	};
	
	document.addEventListener('click', onClick);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(5)();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(root, factory) {
	     true ? // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return root.svg4everybody = factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory() : root.svg4everybody = factory();
	}(this, function() {
	    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
	    function embed(parent, svg, target) {
	        // if the target exists
	        if (target) {
	            // create a document fragment to hold the contents of the target
	            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
	            // conditionally set the viewBox on the svg
	            viewBox && svg.setAttribute("viewBox", viewBox);
	            // copy the contents of the clone into the fragment
	            for (// clone the target
	            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
	                fragment.appendChild(clone.firstChild);
	            }
	            // append the fragment into the svg
	            parent.appendChild(fragment);
	        }
	    }
	    function loadreadystatechange(xhr) {
	        // listen to changes in the request
	        xhr.onreadystatechange = function() {
	            // if the request is ready
	            if (4 === xhr.readyState) {
	                // get the cached html document
	                var cachedDocument = xhr._cachedDocument;
	                // ensure the cached html document based on the xhr response
	                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
	                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
	                xhr._embeds.splice(0).map(function(item) {
	                    // get the cached target
	                    var target = xhr._cachedTarget[item.id];
	                    // ensure the cached target
	                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
	                    // embed the target into the svg
	                    embed(item.parent, item.svg, target);
	                });
	            }
	        }, // test the ready state change immediately
	        xhr.onreadystatechange();
	    }
	    function svg4everybody(rawopts) {
	        function oninterval() {
	            // while the index exists in the live <use> collection
	            for (// get the cached <use> index
	            var index = 0; index < uses.length; ) {
	                // get the current <use>
	                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
	                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
	                svg && src) {
	                    if (polyfill) {
	                        if (!opts.validate || opts.validate(src, svg, use)) {
	                            // remove the <use> element
	                            parent.removeChild(use);
	                            // parse the src and get the url and id
	                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
	                            // if the link is external
	                            if (url.length) {
	                                // get the cached xhr request
	                                var xhr = requests[url];
	                                // ensure the xhr request exists
	                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
	                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
	                                xhr._embeds.push({
	                                    parent: parent,
	                                    svg: svg,
	                                    id: id
	                                }), // prepare the xhr ready state change event
	                                loadreadystatechange(xhr);
	                            } else {
	                                // embed the local id into the svg
	                                embed(parent, svg, document.getElementById(id));
	                            }
	                        } else {
	                            // increase the index when the previous value was not "valid"
	                            ++index, ++numberOfSvgUseElementsToBypass;
	                        }
	                    }
	                } else {
	                    // increase the index when the previous value was not "valid"
	                    ++index;
	                }
	            }
	            // continue the interval
	            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
	        }
	        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
	        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
	        // create xhr requests object
	        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
	        // conditionally start the interval if the polyfill is active
	        polyfill && oninterval();
	    }
	    function getSVGAncestor(node) {
	        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
	        return svg;
	    }
	    return svg4everybody;
	});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var viewport = __webpack_require__(7);
	
	var hiddenClass = 'site-nav__mobile--hidden';
	var openClass = 'site-nav__toggle--open';
	
	var $nav = document.getElementById('site-nav');
	var visible = false;
	
	$nav = {
		root: $nav,
		toggle: document.getElementById('site-nav__toggle'),
		products: document.getElementById('site-nav__products'),
		company: document.getElementById('site-nav__company'),
		mobile: false
	};
	
	var nav = {
		create: function create() {
	
			$nav.mobile = document.createElement('div');
			$nav.mobile.classList.add('site-nav__mobile', hiddenClass);
			document.body.insertBefore($nav.mobile, $nav.root);
			document.body.insertBefore($nav.root, $nav.mobile);
	
			// Add the nav items
			$nav.mobile.appendChild($nav.products);
			$nav.mobile.appendChild($nav.company);
	
			viewport.addListener('nav', function () {
				if (viewport.mq('tablet-wide')) nav.destroy();
			});
		},
		show: function show() {
	
			// If the mobile nav exists
			if ($nav.mobile) {
	
				$nav.mobile.classList.remove(hiddenClass);
				$nav.toggle.classList.add(openClass);
	
				// Create it, then show again
			} else {
				nav.create();
				setTimeout(nav.show, 10);
			}
		},
		hide: function hide() {
			$nav.toggle.classList.remove(openClass);
			$nav.mobile.classList.add(hiddenClass);
		},
		destroy: function destroy() {
	
			// Return the elements to their natural position in the DOM
			$nav.root.insertBefore($nav.products, $nav.root.firstChild);
			$nav.root.appendChild($nav.company);
	
			// Remove the mobile nav
			$nav.mobile.parentNode.removeChild($nav.mobile);
	
			// Reset the variable
			$nav.mobile = false;
	
			// Remove the resize listener
			viewport.removeListener('nav');
	
			// It's hidden now
			visible = false;
		}
	};
	
	$nav.toggle.addEventListener('click', function (e) {
		nav[visible ? 'hide' : 'show']();
		visible = !visible;
		e.preventDefault();
	});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var width = 0,
	    height = 0,
	    prevWidth = void 0,
	    prevHeight = void 0,
	    timer = null;
	
	var breakpoints = {},
	    listeners = {},
	    variables = __webpack_require__(8),
	    update = function update() {
	
		prevWidth = width;
		prevHeight = height;
	
		width = window.innerWidth;
		height = window.innerHeight;
	
		Object.keys(listeners).forEach(function (key) {
			listeners[key](prevWidth !== width, prevHeight !== height);
		});
	};
	
	window.addEventListener('resize', function () {
	
		clearTimeout(timer);
		timer = setTimeout(update, 300);
	});
	
	update();
	
	Object.keys(variables.breakpoints).forEach(function (name) {
		var value = variables.breakpoints[name];
	
		if (variables['em-media-queries']) {
			value /= variables['browser-default-font-size'] || 16;
		}
	
		breakpoints[name] = value;
	});
	
	module.exports = {
		get width() {
			return width;
		},
		get height() {
			return height;
		},
		addListener: function addListener(name, listener) {
			listeners[name] = listener;
		},
		removeListener: function removeListener(name) {
			delete listeners[name];
		},
		mq: function mq(name) {
			var extremum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'min';
			var property = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'width';
	
			var value = breakpoints[name];
	
			if (!value) {
				throw new Error('Unkown breakpoint: ' + name + ' is not defined');
			}
	
			if (extremum === 'max') {
				value -= variables['em-media-queries'] ? 0.01 : 1;
			}
	
			var unit = variables['em-media-queries'] ? 'em' : 'px';
	
			return Modernizr.mq('only screen and (' + extremum + '-' + property + ': ' + value + unit + ')');
		}
	};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = { "rems-on": true, "em-media-queries": true, "browser-default-font-size": 16, "breakpoints": { "phone": 375, "phone-wide": 480, "phablet": 560, "tablet-small": 640, "tablet": 768, "tablet-wide": 1024, "desktop": 1248, "desktop-wide": 1500 } };

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// site.js